export const mappingImageDefault = (image: string) => {
  if(image.match(/item_B62CB79F-1CE7-4D80-86EA-F844804803BE.png/)) return ''
  return image
}